interface NotificationProps {
	title?: string;
	content?: string;
	theme?: 'success' | 'danger' | 'info' | 'warning';
}

const useNotification = () => {
	const handleShowNotification = (args: NotificationProps) => {
		if (args?.content) {
			// @ts-ignore
			MeddiApp.notification(args?.content, args?.title, args?.theme || 'info');
		}
	};

	const showNotificationSuccess = (args: NotificationProps) => {
		handleShowNotification({
			...args,
			theme: 'success',
		});
	};

	const showNotificationAlert = (args: NotificationProps) => {
		handleShowNotification({
			...args,
			theme: 'danger',
		});
	};

	return {
		showNotificationSuccess,
		showNotificationAlert,
	};
};

export default useNotification;
